import { BACKEND_PRIVATE } from '../base'

export async function getProfileInfo() {
  return BACKEND_PRIVATE.get<LX.DashboardProfileInfo>('/me/dashboard/profile')
}
